import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=4a8ec822&scoped=true&lang=pug&"
import script from "./Results.vue?vue&type=script&lang=ts&"
export * from "./Results.vue?vue&type=script&lang=ts&"
import style0 from "./Results.vue?vue&type=style&index=0&id=4a8ec822&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ec822",
  null
  
)

component.options.__file = "Results.vue"
export default component.exports